import { Facebook, Instagram, Mail, MapPin, MessageCircle, Phone, ShieldCheck } from "lucide-react";
import { NAV_LINKS, TRUST } from "@/content";
import { scrollToId } from "@/components/Navbar";

export default function Footer() {
  return (
    <footer id="contact" data-testid="site-footer" className="bg-ink text-cream/80">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img
              src="/logo.jpeg"
              alt="શ્રી યુનિક વિકલાંગ ચેરિટેબલ ટ્રસ્ટ લોગો"
              className="w-12 h-12 rounded-full object-cover bg-white ring-2 ring-saffron/40"
            />
            <span className="font-head font-bold text-cream text-lg leading-tight">
              શ્રી યુનિક વિકલાંગ
              <span className="block text-xs font-medium text-saffron">
                ચેરિટેબલ ટ્રસ્ટ · રાજકોટ
              </span>
            </span>
          </div>
          <p className="text-sm leading-relaxed max-w-xs">
            છેલ્લા ૧૭ વર્ષથી દિવ્યાંગ બંધુઓના સ્વાવલંબન અને સન્માન માટે કટિબદ્ધ —
            સેવા પરમો ધર્મ.
          </p>
          <div className="mt-5 flex items-start gap-2 text-cream/60">
            <ShieldCheck className="w-4 h-4 mt-0.5 text-leaf shrink-0" />
            <p className="font-head text-xs leading-relaxed">
              રજિ. નં: {TRUST.contact.regNo} · CSR: {TRUST.contact.csr}
              <br />
              {TRUST.contact.tax}
            </p>
          </div>
          <div className="mt-6 flex items-center gap-3">
            <a
              data-testid="footer-facebook-button"
              href={TRUST.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook પેજ"
              className="w-11 h-11 rounded-full bg-white/10 border border-white/15 flex items-center justify-center text-cream/80 hover:bg-[#1877F2] hover:text-white hover:border-[#1877F2] transition-colors duration-200"
            >
              <Facebook className="w-5 h-5" />
            </a>
            <a
              data-testid="footer-instagram-button"
              href={TRUST.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram પેજ"
              className="w-11 h-11 rounded-full bg-white/10 border border-white/15 flex items-center justify-center text-cream/80 hover:bg-[#E1306C] hover:text-white hover:border-[#E1306C] transition-colors duration-200"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <a
              data-testid="footer-whatsapp-button"
              href={TRUST.whatsappChat}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp પર ચેટ કરો"
              className="w-11 h-11 rounded-full bg-white/10 border border-white/15 flex items-center justify-center text-cream/80 hover:bg-[#25D366] hover:text-white hover:border-[#25D366] transition-colors duration-200"
            >
              <MessageCircle className="w-5 h-5" />
            </a>
            <span className="font-head text-xs text-cream/50 ml-1">
              Facebook, Instagram અને WhatsApp પર જોડાઓ
            </span>
          </div>
        </div>

        <div>
          <h3 className="font-head font-bold text-cream mb-5">ઝડપી લિંક્સ</h3>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <button
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => scrollToId(l.id)}
                  className="font-head text-sm hover:text-saffron transition-colors"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-head font-bold text-cream mb-5">સંપર્ક</h3>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-1 text-saffron shrink-0" />
              <span data-testid="footer-address">{TRUST.contact.address}</span>
            </li>
            {TRUST.contact.phones.map((p, i) => (
              <li key={p} className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-saffron shrink-0" />
                <a
                  data-testid={`footer-phone-${i}`}
                  href={`tel:${p.replace(/\s/g, "")}`}
                  className="hover:text-saffron transition-colors"
                >
                  {p}
                </a>
              </li>
            ))}
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-saffron shrink-0" />
              <a
                data-testid="footer-email"
                href={`mailto:${TRUST.contact.email}`}
                className="hover:text-saffron transition-colors"
              >
                {TRUST.contact.email}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="font-head text-xs text-cream/50">
            © {new Date().getFullYear()} {TRUST.name}. સર્વ હક્ક સુરક્ષિત.
          </p>
          <p className="font-head text-xs text-cream/50">
            પ્રેમથી બનાવેલું · રાજકોટ, ગુજરાત ·{" "}
            <a data-testid="footer-admin-link" href="/admin" className="hover:text-saffron transition-colors">
              એડમિન
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
